import React from "react";
import Pixel from "./Pixel";
import {Box} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

export default function Row(props) {

  //const {width} = useSelector((state) => state.imageEditor);
  const {row, width , pixelSize} = props;
  let pixels = [];

  for (let i = 0; i < width; i++) {
    pixels.push(<Pixel key={i} row={row} column={i} width={width} pixelSize = {pixelSize}/>);
  }

  return (
    <Box display="flex" width = "fit-content">
        {pixels}
    </Box>

  )
}